module.exports = __webpack_public_path__ + "img/pin-grey.f9041987.svg";